import Vue from 'vue';

const default_locale = window.default_language;
const fallback_locale = window.fallback_locale;
Lang.setLocale(default_locale);
Lang.setFallback(fallback_locale);
Vue.prototype.trans = Lang;